import { useEffect, useState } from "react";
import styled from "@emotion/styled";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
  useParams,
} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "./App.css";
import { responsive } from "./utils/style";
import { css } from "@emotion/react";

import "antd/dist/antd.css";
import "./utils/globalStyle";

import Welcome from "./pages/Welcome";
import WelcomeQuiz from "./pages/WelcomQuiz";
import Login from "./pages/Login";
import Register from "./pages/Register";
import LoginQuiz from "./pages/LoginQuiz";
import RegisterQuiz from "./pages/RegisterQuiz";
import Home from "./pages/Home";
import NutStat from "./pages/Nutstat";
import Nutrition from "./pages/Nutrition";
import NutritionForm from "./pages/Nutrition/form";
import NutritionViews from "./pages/Nutrition/views";
import ForgetPassword from "./pages/ForgetPassword";
import ResetPassword from "./pages/ResetPassword";
import ScoreRules from "./pages/ScoreRules";
import Article from "./pages/Article";
import Reward from "./pages/Reward";
import ChangePassword from "./pages/ChangePassword";
import ReportMonk from "./pages/ReportMonk";
import Profile from "./pages/Profile";
import EditProfile from "./pages/Profile/edit";
import MonkHelper from "./pages/MonkHelper";
import Inform from "./pages/Inform";
import Report from "./pages/Report";
import Description from "./pages/Description";
import Ranking from "./pages/Ranking";
import GenCodePassword from "./pages/GenCodePassword";
import GenCodePasswordStaff from "./pages/GenCodePassword/staffTable";
import GenCodePasswordStudent from "./pages/GenCodePassword/studentTable";

import { onGetUserInfo } from "./stores/auth";

import Navbar from "./components/Navbar/Navbar";
import Confirmation from "./pages/Confirmation";
import Footer from "./components/Footer/Footer";

import useAuth from "./utils/useAuth";
import PrivacyNotice from "./pages/Pdpa/PrivacyNotice";
import CookiePolicy from "./pages/Pdpa/CookiePolicy";
import ScrollToTop from "./components/ScrollToTop";
import CookieModal from "./components/Pdpa/CookieModal";
import ChromeModal from "./components/ChromeModal";

import PageView from "./PageView";
import { Quiz } from "./pages/Quiz";
import { QuizSummaryScore } from "./pages/Quiz/summary";
import QuizDoing from "./pages/Quiz/doing";
import RightAnswer from "./pages/Quiz/rightAnswer";
import { ProtectedRoute } from "./components/ProtectedRoute";

function App() {
  const initialized = useSelector((s) => s.auth.initialized);
  const dispatch = useDispatch();
  let { isStudent, isStaff, username, isAdmin } = useAuth();
  const [showMenuMobile, setShowMenuMobile] = useState(false);
  const [showAccountMenu, setShowAccountMenu] = useState(false);

  const narbarProps = {
    showMenuMobile,
    setShowMenuMobile,
    showAccountMenu,
    setShowAccountMenu,
  };

  useEffect(() => {
    dispatch(onGetUserInfo());
  }, [dispatch]);

  if (!initialized) return <></>;

  return (
    <BrowserRouter>
      <PageView />
      <ScrollToTop>
        <Navbar {...narbarProps} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
          <Route
            path="login/quiz"
            element={username ? <Navigate replace to="/quiz" /> : <LoginQuiz />}
          />
          <Route
            path="register/quiz"
            element={
              username ? <Navigate replace to="/quiz" /> : <RegisterQuiz />
            }
          />
          <Route path="nutstat" element={<NutStat />} />
          <Route
            path="nutrition"
            element={
              isStudent || isStaff ? (
                <Nutrition />
              ) : (
                <Navigate replace to="/nutstat" />
              )
            }
          />
          <Route
            path="nutrition/views/:step"
            element={
              isStaff ? <NutritionViews /> : <Navigate replace to="/nutstat" />
            }
          />
          <Route
            path="nutrition/form/:step"
            element={
              isStudent || isStaff ? (
                <NutritionForm />
              ) : (
                <Navigate replace to="/nutstat" />
              )
            }
          />
          <Route path="forgetPassword" element={<ForgetPassword />} />
          <Route path="resetPassword" element={<ResetPassword />} />
          <Route path="scoreRules" element={<ScoreRules />} />
          <Route path="article/:type" element={<Article />} />
          <Route path="reward" element={<Reward />} />
          <Route path="changePassword" element={<ChangePassword />} />
          <Route path="/ranking" element={<Ranking />} />
          <Route
            path="/quiz"
            element={
              <ProtectedRoute>
                <Quiz />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quiz/do/:group"
            element={
              <ProtectedRoute>
                <QuizDoing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quiz/summaryScore"
            element={
              <ProtectedRoute condition={!isStaff}>
                <QuizSummaryScore />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quiz/rightAnswers"
            element={
              <ProtectedRoute condition={isStaff}>
                <RightAnswer />
              </ProtectedRoute>
            }
          />
          <Route
            path="reportMonk"
            element={isStudent ? <ReportMonk /> : <Navigate replace to="/" />}
          />
          <Route path="monkHelper/:type" element={<MonkHelper />} />
          <Route path="inform" element={<Inform />} />
          <Route path="profile" element={<Profile />} />
          <Route path="profile/edit" element={<EditProfile />} />
          <Route path="getStarted" element={<Welcome />} />
          <Route path="getStartedQuiz" element={<WelcomeQuiz />} />
          <Route
            path="report"
            element={isStaff ? <Report /> : <Navigate replace to="/" />}
          />
          <Route path="confirmation" element={<Confirmation />} />
          <Route path="description" element={<Description />} />
          <Route path="privacyNotice" element={<PrivacyNotice />} />
          <Route path="cookiePolicy" element={<CookiePolicy />} />
          <Route
            path="genCodePassword"
            element={
              isStaff ? <GenCodePassword /> : <Navigate replace to="/" />
            }
          />
          <Route
            path="genCodePassword/staff"
            element={
              isStaff ? <GenCodePasswordStaff /> : <Navigate replace to="/" />
            }
          />
          <Route
            path="genCodePassword/student"
            element={
              isStaff ? <GenCodePasswordStudent /> : <Navigate replace to="/" />
            }
          />
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
        <Footer />
        {showMenuMobile || showAccountMenu ? (
          <SmokeScreen
            onClick={() => {
              setShowMenuMobile(false);
              setShowAccountMenu(false);
            }}
          />
        ) : null}
        <ChromeModal />
        <CookieModal />
      </ScrollToTop>
    </BrowserRouter>
  );
}

const SmokeScreen = styled.div`
  display: none;
  height: 100%;
  width: 100%;
  background-color: #000;
  z-index: 9;
  opacity: 0.5;

  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: auto;

  ${responsive.semiMobile(css`
    display: flex;
  `)};
`;

export default App;
